import { isServiceProviderSupportUser, isSuperUserOrDeveloper } from '../services/usercapabilities.service';
import { User } from '../store/user/user.types';

export function isReadOnly(user: User, tenantId: string, boardId: string): boolean {
  const tenant = user.tenants.find((tenant) => tenant.id === tenantId);
  const board = tenant?.boards?.find((board) => board.id === boardId);

  if (isSuperUserOrDeveloper(user.globalRoles)) {
    return false;
  }

  if (isServiceProviderSupportUser(user) && board?.role !== 'BOARD_VIEWER') {
    return false;
  }

  if (tenant?.role === 'TENANT_OWNER' && board?.role !== 'BOARD_VIEWER') {
    return false;
  }

  if (tenant?.role === 'TENANT_MEMBER' && board?.role !== 'BOARD_VIEWER') {
    return false;
  }

  if (board?.role === 'BOARD_OWNER') {
    return false;
  }

  if (board?.role === 'BOARD_EDITOR') {
    return false;
  }

  if (board?.role === 'BOARD_VIEWER') {
    return true;
  }

  return true;
}
